module.exports = __webpack_public_path__ + "static/img/发票管理2.18fb8043.png";